import { Link } from "react-router-dom";
import { Check, Minus } from "lucide-react";
import { PageHero, SectionHead } from "@/components/site/Section";
import { PricingCards } from "@/components/site/PricingCards";
import { useCurrency } from "@/context/CurrencyContext";
import { fmtMoney } from "@/lib/api";
import { FaqList } from "@/pages/site/Home";
import { FAQS } from "@/data/content";

const ROWS = [
  ["Workspaces", "1", "1", "1"], ["Users", "2", "5", "15"], ["Connected channels", "3", "8", "20"],
  ["AI credits / month", "2,000", "6,000", "15,000"], ["Brand Profile & Knowledge Base", true, true, true],
  ["AI Content Studio", true, true, true], ["Two-week AI content calendar", true, true, true],
  ["Approval workflow", true, true, true], ["Social & blog publishing (demo)", true, true, true],
  ["SEO & blog assistant", false, true, true], ["Paid campaign drafting", false, true, true],
  ["Events & webinar promotion", false, true, true], ["Weekly report", "Basic", "Expanded", "Advanced"],
  ["Priority support", false, false, true],
];
const Cell = ({ v }) => (v === true ? <Check className="h-4 w-4 text-[#10b981] mx-auto" /> : v === false ? <Minus className="h-4 w-4 text-muted-foreground mx-auto" /> : <span>{v}</span>);

const Packs = () => {
  const { currency, config } = useCurrency();
  if (!config) return null;
  return (
    <div className="grid sm:grid-cols-3 gap-5">
      {Object.entries(config.packs).map(([id, p]) => (
        <div key={id} className="card-box p-6 lift" data-testid={`credit-pack-${id}`}>
          <div className="font-display text-2xl font-bold">{p.name}</div>
          <div className="mt-2 text-3xl font-extrabold text-gradient">{fmtMoney(p.prices[currency], currency, config.symbols)}</div>
          <Link to={`/checkout?type=credits&item=${id}`} className="btn-ghost mt-6 w-full" data-testid={`buy-pack-${id}`}>Buy credits</Link>
        </div>
      ))}
    </div>
  );
};

export default function Pricing() {
  return (
    <div data-testid="pricing-page">
      <PageHero eyebrow="Pricing" title={<>Choose a Plan That <span className="text-gradient">Fits Your Business</span></>}
        copy="Transparent monthly plans in INR, USD, EUR, GBP or AED. No long-term commitment — cancel any time from Billing." />
      <section className="py-20"><div className="container-x"><PricingCards /></div></section>
      <section className="py-16 border-t">
        <div className="container-x">
          <SectionHead eyebrow="Compare" title="Compare All Plans" />
          <div className="mt-10 overflow-x-auto rounded-2xl border">
            <table className="w-full text-sm" data-testid="plan-compare-table">
              <thead className="bg-card"><tr><th className="p-4 text-left">Feature</th>{["Starter", "Growth", "Pro"].map((h) => <th key={h} className="p-4 text-center font-display">{h}</th>)}</tr></thead>
              <tbody>{ROWS.map(([f, ...v]) => <tr key={f} className="border-t"><td className="p-4">{f}</td>{v.map((x, i) => <td key={i} className="p-4 text-center"><Cell v={x} /></td>)}</tr>)}</tbody>
            </table>
          </div>
        </div>
      </section>
      <section id="credits" className="py-20 border-t bg-card/40 scroll-mt-20">
        <div className="container-x">
          <SectionHead eyebrow="AI credits" title="Flexible AI Usage. Clearer Costs."
            copy="Each AI task uses credits: social post 5 · ad copy 6 · email 8 · webinar copy 8 · SEO brief 10 · blog draft 20 · campaign draft 25 · two-week calendar 30. The cost is shown before every task; failed tasks are never charged. Bring-your-own AI provider is Coming Soon." />
          <div className="mt-10"><Packs /></div>
        </div>
      </section>
      <section className="py-20 border-t">
        <div className="container-x grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4"><SectionHead eyebrow="FAQ" title="Billing questions" /></div>
          <div className="lg:col-span-8"><FaqList items={FAQS.slice(4)} /></div>
        </div>
      </section>
    </div>
  );
}
